import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const Quantity = {
  id: 'totalQuantity',
  type: OptionFormTypes.TYPE_NUMBER_COMPARISON,
  filterValue: 'Quantity',
  displayName: <FormattedMessage {...messages.quantity} />,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_NUMBER_COMPARISON, criteriaInformations);
  },
};
